import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BlockAlignmentCenterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BlockAlignmentCenter",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.15 17.76v-3.48a4.1 4.1 0 0 1 4.1-4.1h17.51a4.1 4.1 0 0 1 4.1 4.1v3.48a4.1 4.1 0 0 1-4.1 4.1H7.25a4.1 4.1 0 0 1-4.1-4.1M16.05 30h-.09c-.62 0-1.12-.5-1.12-1.12v-3.6c0-.62.5-1.12 1.12-1.12h.09c.62 0 1.12.5 1.12 1.12v3.6c0 .62-.5 1.12-1.12 1.12M15.9 2h.21c.59 0 1.06.48 1.06 1.06v3.72c0 .59-.48 1.06-1.06 1.06h-.21c-.59 0-1.06-.48-1.06-1.06V3.06c0-.59.48-1.06 1.06-1.06"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 28.01c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v22.01c0 .55-.45 1-1 1M12 21H7c-1.65 0-3-1.35-3-3v-4c0-1.65 1.35-3 3-3h5c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1 .45 1 1s-.45 1-1 1M25 21h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c1.65 0 3 1.35 3 3v4c0 1.65-1.35 3-3 3"
      })
    })
  }));
};